export function ite(condition, trueValue, falseValue) {
    return condition ? trueValue : falseValue;
}
